import { motion } from 'framer-motion';

const PageTransition = ({ children, theme }) => {
  const contentVariants = {
    initial: {
      opacity: 0,
      scale: 0.95,
    },
    animate: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.8, ease: [0.42, 0, 0.58, 1], delay: 0.3 },
    },
    exit: {
      opacity: 0,
      scale: 1.05,
      transition: { duration: 0.6, ease: 'easeInOut' },
    },
  };

  return (
    <motion.div
      initial="initial"
      animate="animate"
      exit="exit"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: theme.backgroundColor,
        zIndex: 10,
        overflow: 'hidden',
      }}
    >
      {/* Seiteninhalt */}
      <motion.div
        variants={contentVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        style={{
          position: 'relative',
          height: '100%',
          width: '100%',
        }}
      >
        {children}
      </motion.div>
    </motion.div>
  );
};

export default PageTransition;
